/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayerSearchOptionsPayerRequiredFieldsInner } from './PayerSearchOptionsPayerRequiredFieldsInner';
import {
    PayerSearchOptionsPayerRequiredFieldsInnerFromJSON,
    PayerSearchOptionsPayerRequiredFieldsInnerFromJSONTyped,
    PayerSearchOptionsPayerRequiredFieldsInnerToJSON,
    PayerSearchOptionsPayerRequiredFieldsInnerToJSONTyped,
} from './PayerSearchOptionsPayerRequiredFieldsInner';
import type { EligibilityStcModel } from './EligibilityStcModel';
import {
    EligibilityStcModelFromJSON,
    EligibilityStcModelFromJSONTyped,
    EligibilityStcModelToJSON,
    EligibilityStcModelToJSONTyped,
} from './EligibilityStcModel';

/**
 * 
 * @export
 * @interface PayerSearchOptions
 */
export interface PayerSearchOptions {
    /**
     * Number of days ahead service dates can be searched
     */
    service_date_days_ahead?: number;
    /**
     * Number of days back service dates can be searched
     */
    service_date_days_back?: number;
    /**
     * Number of months ahead service dates can be searched
     */
    service_date_months_ahead?: number;
    /**
     * Number of months back service dates can be searched
     */
    service_date_months_back?: number;
    /**
     * Whether service date ranges are supported
     */
    is_service_date_ranged?: boolean;
    /**
     * List of supported service type codes
     */
    eligibility_stc_models?: Array<EligibilityStcModel>;
    /**
     * Additional fields required by this payer
     */
    payer_required_fields?: Array<PayerSearchOptionsPayerRequiredFieldsInner>;
    /**
     * Maximum number of service type codes allowed
     */
    max_stcs?: number;
    /**
     * ID of the payer type
     */
    payer_type_id?: number;
}

/**
 * Check if a given object implements the PayerSearchOptions interface.
 */
export function instanceOfPayerSearchOptions(value: object): value is PayerSearchOptions {
    return true;
}

export function PayerSearchOptionsFromJSON(json: any): PayerSearchOptions {
    return PayerSearchOptionsFromJSONTyped(json, false);
}

export function PayerSearchOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerSearchOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'service_date_days_ahead': json['service_date_days_ahead'] == null ? undefined : json['service_date_days_ahead'],
        'service_date_days_back': json['service_date_days_back'] == null ? undefined : json['service_date_days_back'],
        'service_date_months_ahead': json['service_date_months_ahead'] == null ? undefined : json['service_date_months_ahead'],
        'service_date_months_back': json['service_date_months_back'] == null ? undefined : json['service_date_months_back'],
        'is_service_date_ranged': json['is_service_date_ranged'] == null ? undefined : json['is_service_date_ranged'],
        'eligibility_stc_models': json['eligibility_stc_models'] == null ? undefined : ((json['eligibility_stc_models'] as Array<any>).map(EligibilityStcModelFromJSON)),
        'payer_required_fields': json['payer_required_fields'] == null ? undefined : ((json['payer_required_fields'] as Array<any>).map(PayerSearchOptionsPayerRequiredFieldsInnerFromJSON)),
        'max_stcs': json['max_stcs'] == null ? undefined : json['max_stcs'],
        'payer_type_id': json['payer_type_id'] == null ? undefined : json['payer_type_id'],
    };
}

export function PayerSearchOptionsToJSON(json: any): PayerSearchOptions {
    return PayerSearchOptionsToJSONTyped(json, false);
}

export function PayerSearchOptionsToJSONTyped(value?: PayerSearchOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_date_days_ahead': value['service_date_days_ahead'],
        'service_date_days_back': value['service_date_days_back'],
        'service_date_months_ahead': value['service_date_months_ahead'],
        'service_date_months_back': value['service_date_months_back'],
        'is_service_date_ranged': value['is_service_date_ranged'],
        'eligibility_stc_models': value['eligibility_stc_models'] == null ? undefined : ((value['eligibility_stc_models'] as Array<any>).map(EligibilityStcModelToJSON)),
        'payer_required_fields': value['payer_required_fields'] == null ? undefined : ((value['payer_required_fields'] as Array<any>).map(PayerSearchOptionsPayerRequiredFieldsInnerToJSON)),
        'max_stcs': value['max_stcs'],
        'payer_type_id': value['payer_type_id'],
    };
}

